module.exports = __webpack_public_path__ + "static/media/NEXUS-101-badge.5a9b45d7.svg";